import styled, { css } from 'styled-components'

import FormLabel from '../../FormLabel'
import FormFieldToggleButton from '../FormFieldToggleButton'

export const Wrapper = styled.div<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`

export const Label = styled(FormLabel)`
  margin-bottom: 0.5rem;
`

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
`

export const Checkbox = styled(FormFieldToggleButton)``

export const Error = styled.p`
  ${({ theme }) => theme.textStyles.text}
  color: ${({ theme }) => theme.colors.red};
  margin-top: 0.5rem;
`

export const Help = styled.p`
  ${({ theme }) => theme.textStyles.textSmall}
  color: grey;
  margin-top: 0.5rem;
`
